import axiosInstance from "../api/axios";
import { createContext, useMemo } from "react";

export let BreedContext = createContext();

// Fetch all animals
function BreedMenue() {
    return axiosInstance.get('/breed/GetAll-breeds-menue')
    .then((response) => response)
    .catch((err) => err);
}

//Remove an animal by ID
function removeBreed(id) {
    return axiosInstance.delete(`/breed/deletebreed/${id}`)
        .then((response) => response)
        .catch((error) => error);
}

// Fetch all breed
function getBreed(page, limit, filters = {}) {
    return axiosInstance.get(`/breed/GetAll-breeds`, {
        params: {
            page,
            limit,
            ...filters 
        }
    })
    .then((response) => response)
    .catch((error) => error);
}

// Context Provider
export default function BreedContextProvider(props) {
    // Memoize context value to prevent unnecessary re-renders
    const contextValue = useMemo(
        () => ({ BreedMenue, getBreed, removeBreed }),
        [] // Functions are stable, no dependencies needed
    );

    return (
        <BreedContext.Provider value={contextValue}>
            {props.children}
        </BreedContext.Provider>
    );
}